<template>
  <li class="treeview-item-li" v-bind:style="paddingLeft" :class="{hasChild: item[childrenField]}">
    <div class="treeview-item"
         :class="[ (item.selected && !sortingItem) || sorting ? 'treeview-item-selected' : 'treeview-item-unselected' ]">
      <div v-if="item[childrenField]" class="treeview-item-folder flex-grow-1">
      <!-- @mouseover="onMouseOver(true)"
           @mouseleave="onMouseOver(false)" -->
        <i v-if="!sortingItem && !hasSlotName('default') && item.open" @click="toggle" class="fas fa-chevron-circle-down px-1 text-third treeview-item-icon"></i>
        <i v-else-if="!sortingItem && !hasSlotName('default')" @click="toggle" class="fas fa-chevron-circle-right px-1 text-third treeview-item-icon"></i>
        <i v-else class="fas fa-circle px-1 text-warning treeview-item-icon"></i>
        <input type="checkbox"
               ref="fatherCheckbox"
               class="mr-1"
               name="cbxAction"
               :indeterminate.prop="indeterminate(item)"
               :checked.prop="checked(item)"
               v-if="!sortingItem && getShowCheckbox"
               @change="propagate">
        <b-link href="#"
                tabindex="-1"
                class="text-secondary"
                @click="onSelectItem(item)"
                v-if="!sortingItem"
                style="cursor:block;">
          <span ref="txtItem" class="treeview-text" :class="{'text-danger font-weight-bold': item.found}" v-if="! hasSlotName('default')">{{ serializer(item) }}</span>
          <slot :item="item"></slot>
        </b-link>
        <span class="text-secondary treeview-text" v-if="sortingItem">{{serializer(item)}}</span>
      </div>
      <div v-else :class="[ item.status > 0 ? 'text-default' : 'text-danger' ]" class="treeview-item-folder flex-grow-1">
        <input type="checkbox"
               ref="fatherCheckbox"
               class="mr-1"
               name="cbxAction"
               v-model="item[checkboxField]"
               v-if="!sortingItem && getShowCheckbox"
               @change="onCheckItem(item)">
        <b-link href="#"
                tabindex="-1"
                class="text-secondary"
                @click="onSelectItem(item)"
                v-if="!sortingItem"
                style="cursor:block;">
          <span ref="txtItem" class="treeview-text" :class="{'text-danger font-weight-bold': item.found}">{{ serializer(item) }}</span>
          <slot :item="item"></slot>
        </b-link>
        <span class="treeview-text" v-if="sortingItem">{{serializer(item)}}</span>
        <i class="fas fa-eye px-1"
           :id="'item-' + item.value"
           :class="item.contracts.length ? 'text-primary' : 'text-info'"
           v-if="!sortingItem && !sorting && !item[childrenField] && item.contracts && item.contracts.length"
           :style="getStyleUsedContracts(item)">
           <b-popover id="pop-contracts" :target="'item-' + item.value"
                      triggers="hover"
                      placement="right"
                      boundary="viewport">
             <b-card :header="$lang.PCI.DataTable.Contract" class="m-0">
               <div v-for="(contract, idx) in item.contracts" :key="idx" class="m-0 p-1" :class="{'contracts-odd': ((idx % 2) !== 0)}">
                 {{ contract }}
               </div>
             </b-card>
           </b-popover>
        </i>
      </div>
      <div id="sorting" class="form-inline flex-nowrap">
        <i class="fa fa-save text-third px-1 ml-auto" style="font-size: 14px;cursor:pointer;" v-if="sorting" @click="onSaveSorting"></i>
        <i class="fa fa-times text-danger px-1 ml-auto" style="font-size: 14px;cursor:pointer;" v-if="sorting" @click="onCancelSorting"></i>
      </div>
      <div id="actionButtonsDiv"
           class="form-inline flex-nowrap">
        <slot name="actionButtons" :item="item" :index="index" :length="length"></slot>
        <i class="fa fa-sort text-primary px-1" style="cursor:pointer;" v-if="!sortingItem && !sorting && showSortButton && item[childrenField]" @click="onSorting(item)"></i>
        <i class="fa fa-plus-circle text-third px-1"
           style="cursor:pointer;"
           v-if="!sortingItem && !sorting && getShowAddButton"
           v-on:click="onAdd(item, $event)">
        </i>
        <b-dropdown href="#"
                    variant="link"
                    toggle-class="text-decoration-none"
                    v-if="!sortingItem && !sorting && getShowDeleteButton"
                    no-caret
                    tabindex="-1"
                    @mouseover="onDeleteMouseOver(true)">
          <template #button-content>
            <i class="fa fa-trash text-danger px-1" style="cursor:pointer"></i>
          </template>
          <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
          <b-dropdown-item href="#" v-on:click="onDelete(item)">{{$lang.Common.Yes}}</b-dropdown-item>
          <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
        </b-dropdown>
        <b-popover :content="serializer(item)"
                   target="actionButtonsDiv"
                   :show.sync="showPopover"
                   placement="right"
                   boundary="viewport"
                   :boundaryPadding="10">
        </b-popover>
      </div>
      <div id="afterSerialize" class="form-inline flex-nowrap">
        <slot name="afterSerialize" :item="item"></slot>
      </div>
    </div>
    <ul class="pl-3" v-if="item.open && item[childrenField]" v-show="!sorting">
      <item-tree-view-item v-for="(subitem, subindex) in item[childrenField]"
                           ref="treeviewItem"
                           :key="subitem[idField]"
                           :item="subitem"
                           :startOpen="startOpen"
                           :showAddButton="showAddButton"
                           :showDeleteButton="showDeleteButton"
                           :showSortButton="showSortButton"
                           :showCheckbox="showCheckbox"
                           :serializer="serializer"
                           :childrenField="childrenField"
                           :index="subindex"
                           :length="item[childrenField].length"
                           :idField="idField"
                           v-on:add="onAdd"
                           v-on:delete="onDelete"
                           v-on:selectitem="onSelectItem"
                           v-on:checkitem="onCheckItem"
                           v-on:open="doOpen"
                           v-on:startSorting="(list) => $emit('startSorting', list)"
                           v-on:cancelSorting="$emit('cancelSorting')"
                           v-on:saveSorting="$emit('saveSorting')">

        <template #default="slotProps">
          <slot :item="slotProps.item"></slot>
        </template>

        <template #actionButtons="slotProps">
          <slot name="actionButtons" :item="slotProps.item" :index="slotProps.index" :length="slotProps.length"></slot>
        </template>

        <template #afterSerialize="slotProps">
          <slot name="afterSerialize" :item="slotProps.item"></slot>
        </template>

      </item-tree-view-item>
    </ul>
    <draggable tag="ul"
               class="list-group ml-4 mt-1"
               v-if="sorting"
               :list="item[childrenField]"
               ghost-class="sortable-ghost"
               @start="drag = true"
               @end="drag = false"
               :animation="100">

      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <li class="p-1 list-group-item" v-for="it in item[childrenField]" :key="it[idField]">{{it.order + ' - ' + serializer(it)}}</li>
      </transition-group>

    </draggable>
  </li>
</template>

<script>
import ItemTreeViewItem from './ItemTreeViewItem.vue'
import draggable from 'vuedraggable'

export default {
  name: 'ItemTreeViewItem',
  data () {
    return {
      selected: false,
      paddingLeft: 'padding-left: ' + this.item.level + '0px',
      cbxAction: this.item.checked,
      showActionButtons: false,
      showPopover: false,
      show: this.showPopover,
      isOnDeleteButton: false,
      sorting: false,
      sortingItem: false,
      drag: false
    }
  },
  props: {
    item: {type: Object, required: true},
    startOpen: {type: Boolean, required: false, default: false},
    showAddButton: {type: [Boolean, Function], required: false, devault: false},
    showDeleteButton: {type: [Boolean, Function], required: false, devault: false},
    showSortButton: {type: [Boolean, Function], required: false, devault: false},
    showCheckbox: {type: [Boolean, Function], required: false, default: false},
    checkboxField: {type: String, required: false, default: 'checked'},
    serializer: {type: Function, required: true},
    childrenField: {type: String, required: false, default: 'children'},
    idField: {type: String, required: true},
    index: {type: Number, required: true},
    length: {type: Number, required: true}
  },
  components: {
    ItemTreeViewItem,
    draggable
  },
  computed: {
    getShowAddButton () {
      return typeof this.showAddButton === 'function' ? this.showAddButton(this.item) : this.showAddButton
    },
    getShowDeleteButton () {
      return typeof this.showDeleteButton === 'function' ? this.showDeleteButton(this.item) : this.showDeleteButton
    },
    getShowCheckbox () {
      return typeof this.showCheckbox === 'function' ? this.showCheckbox(this.item) : this.showCheckbox
    }
  },
  methods: {
    closeAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.closeAll()
        })
      }
      this.$nextTick(() => {
        this.$set(this.item, 'open', false)
      })
    },
    openAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.openAll()
        })
      }
      this.$nextTick(() => {
        this.$set(this.item, 'open', true)
      })
    },
    onAdd (item, event) {
      event.stopPropagation()
      event.preventDefault()
      this.$set(this.item, 'open', true)
      this.$emit('add', item, event)
    },
    onDelete (item) {
      this.$emit('delete', item)
    },
    onSorting (item) {
      this.sorting = true
      this.$emit('startSorting', item[this.childrenField])
    },
    onSortingItem (sorting) {
      this.sortingItem = sorting
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(ti => {
          ti.onSortingItem(sorting)
        })
      }
    },
    onSaveSorting () {
      this.$emit('saveSorting')
    },
    confirmSaveSorting () {
      this.sorting = false
      this.onSortingItem(false)
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(ti => ti.confirmSaveSorting())
      }
    },
    onCancelSorting () {
      this.item[this.childrenField].sort((a, b) => a.order - b.order)
      this.sorting = false
      this.$emit('cancelSorting')
    },
    onSelectItem (item) {
      this.$emit('selectitem', item)
    },
    onCheckItem (item) {
      this.$emit('checkitem', item)
    },
    propagate (event) {
      const _propagate = (_item) => {
        if (_item[this.childrenField]) {
          _item[this.childrenField].forEach((t) => {
            _propagate(t)
          })
        } else {
          this.$set(_item, this.checkboxField, event.target.checked)
          this.$emit('checkitem', _item)
        }
      }

      _propagate(this.item)
    },
    indeterminate (item) {
      if (item[this.childrenField]) {
        let checked = 0
        let count = 0

        const setChecked = (it) => {
          if (it[this.childrenField]) {
            it[this.childrenField].forEach(c => setChecked(c))
          } else {
            count++
            if (it.checked) {
              checked++
            }
          }
        }

        setChecked(item)

        return checked > 0 && checked < count
      }
      return false
    },
    checked (item) {
      if (item[this.childrenField]) {
        let checked = true

        const setChecked = (it) => {
          if (it[this.childrenField]) {
            it[this.childrenField].forEach(c => setChecked(c))
          } else {
            checked = checked && it.checked
          }
        }

        setChecked(item)

        return checked
      }
      return false
    },
    onDeleteMouseOver (over) {
      this.isOnDeleteButton = over
    },
    onMouseOver (over) {
      if (!this.isOnDeleteButton) {
        console.log(new Date(), over, this.isOnDeleteButton)
        this.showActionButtons = over
        const parent = this.$refs.txtItem ? this.$refs.parentElement : null
        this.showPopover = over && parent && parent.offsetWidth !== parent.scrollWidth
      }
    },
    doOpen (item) {
      this.$set(this.item, 'open', true)
      this.$emit('open', item)
    },
    toggle () {
      if (!this.item.open) {
        this.$emit('open', this.item)
        this.$nextTick(() => {
          this.$set(this.item, 'open', !this.item.open)
        })
      } else {
        this.$set(this.item, 'open', false)
      }
    },
    hasSlotName (name) {
      return this.$slots[name] && this.$slots[name].length > 0
    },
    getStyleUsedContracts (item) {
      return {
        cursor: item.contracts.length ? 'pointer' : 'default',
        opacity: item.contracts.length ? '1' : '0.40'
      }
    }
  }
}
</script>

<style scoped>
.treeview-item {
  height: 29px;
  border-bottom: 1px solid transparent;
}

.treeview-item-selected {
  box-shadow: 0px 0.5px 1px 0px grey;
  background-color: #e6e9ea94;
  font-weight: bold;
}

.treeview-item:hover {
  background-color: #e6e9ea47;
  border-bottom: 1px solid lightgray;
}

.treeview-item-folder {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.treeview-item-li {
  list-style-type: disc;
  margin-left: 25px;
}

.treeview-item-li.hasChild {
  list-style-type: none;
  margin-left: 0;
}

.treeview-text {
  font-size: 12px;
}

.treeview-item input[type="checkbox"] {
  cursor: pointer;
  vertical-align: middle;
}

i.treeview-item-icon {
  padding: 5px;
}

a.disabled {
  pointer-events: none;
  opacity: 30%;
}

* >>> .btn-link {
  padding: 0;
  border: none;
  box-shadow: none;
}

#actionButtonsDiv {
  display: none;
}

.treeview-item:hover > #actionButtonsDiv {
  display: flex;
}

.list-group-item {
  cursor: grab;
}
.sortable-ghost {
  opacity: 0.5;
  background: #c8fbd6;
}
.flip-list-move {
  transition: transform 0.2s;
}
.no-move {
  transition: transform 0s;
}

#pop-contracts .card-body {
  max-height: 500px;
  font-size: 0.6rem;
  overflow-y: auto;
}
#pop-contracts .card-body .contracts-odd {
  background-color: #eceff1;
}
#pop-contracts .card-body::-webkit-scrollbar-track {
  border-radius: 12px !important;
  background: #fcfcfc !important;
}

#pop-contracts .card-body::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: #c2c2c2 !important;
}

#pop-contracts .card-body::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

#pop-contracts .card-body::-webkit-scrollbar-thumb:hover {
  border-radius: 10px !important;
  background: #a1a1a1 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/treeview/ItemTreeViewItem.vue